export interface ToolField {
  id: string
  question: string
  options: string[]
  guessOptions?: string[]
}

export const signalCheckCards: ToolField[] = [
  {
    id: 'saw',
    question: 'What did I see or hear?',
    options: ['Panther watched grass.', 'Monkey stopped at water.', 'Meerkats repeated a sound.', 'Leave blank.'],
  },
  {
    id: 'guess',
    question: 'What am I guessing?',
    options: ['The laughter is about Amara.', 'Monkey caused danger.', 'The hiss is harmless.', 'Not sure.'],
    guessOptions: ['The laughter is about Amara.', 'Monkey caused danger.', 'The hiss is harmless.'],
  },
  {
    id: 'check',
    question: 'What do I need to check?',
    options: ['Where did the hiss come from?', 'What did the full sound mean?', 'What support would help?', 'Leave blank.'],
  },
  {
    id: 'move',
    question: 'What is one safe next move?',
    options: ['Watch from a safe spot.', 'Make the side path clear.', 'Ask Sentinel.', 'Pause.', 'Leave blank.'],
  },
]

export const wateringMapFields: ToolField[] = [
  {
    id: 'steady',
    question: 'Steadying action',
    options: ['Tap a slow beat.', 'Look at one clear thing.', 'Move to a quieter spot.', 'Skip.'],
  },
  {
    id: 'place',
    question: 'Safer place',
    options: ['Acacia shade.', 'Side-water path.', 'Quiet corner.', 'Skip.'],
  },
  {
    id: 'helper',
    question: 'Helper',
    options: ['Giraffe.', 'Antelope.', 'Sentinel.', 'A trusted adult.', 'Skip.'],
  },
  {
    id: 'words',
    question: 'Helpful words',
    options: ['I need a minute.', 'Can you stay nearby?', 'Can you help me check?', 'I am not ready to talk.', 'Skip.'],
  },
  {
    id: 'route',
    question: 'Next route',
    options: ['Pause.', 'Make space.', 'Ask for help.', 'Wait with support.', 'Come back later.', 'Skip.'],
  },
]

export const privacyCopy =
  'These selections stay in this page during your visit. This app does not send them to a school, parent, teacher, or AI. Refreshing may clear them.'
